export const CURRENT_LS_VERSION = 1;

export const LS_KEY_PREFIX = `PNID_CONTEXTUALIZATION`;
export const LS_KEY_METRICS = `${LS_KEY_PREFIX}-METRICS`;
export const LS_KEY_SETTINGS = `${LS_KEY_PREFIX}-SETTINGS`;
